const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  env: process.env.REACT_APP_ENV,
  appName: process.env.REACT_APP_NAME || 'HR Portal',
  isDev: process.env.REACT_APP_ENV === 'development',
};

export default config;